<div class="container is-flex">
  <img class="image" [srcset]="srcset">
</div>